var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrokenHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 49,
    viewBox: "0 0 51 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4432 0.437508H36.3126C34.3516 0.435869 32.4124 0.849007 30.6224 1.6498L24.3535 14.1875L33.5202 22.2083L23.2077 37.1042L27.791 23.3542L17.4785 15.3333L23.0667 3.22418C20.6518 1.41221 17.7133 0.434198 14.6941 0.437508H14.5601C10.7851 0.453437 7.16899 1.95829 4.49722 4.62512C1.82545 7.29195 0.313923 10.9053 0.291016 14.6802C0.291016 28.1667 23.7806 47.4877 24.774 48.3035C24.9787 48.4709 25.235 48.5623 25.4993 48.5623C25.7637 48.5623 26.02 48.4709 26.2247 48.3035C27.2238 47.4877 50.7077 28.1667 50.7077 14.6756C50.6854 10.9018 49.1745 7.28922 46.5035 4.62311C43.8324 1.95701 40.2171 0.45284 36.4432 0.437508Z",
    fill: "#CC6844"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenHeart);
export default __webpack_public_path__ + "static/media/broken-heart.f2e668e9.svg";
export { ForwardRef as ReactComponent };